import React from 'react';
import { toDataSourceRequestString, translateDataSourceResultGroups } from '@progress/kendo-data-query';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom';
import {authHeader} from '../../_helpers/auth-header'
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import numbers from 'cldr-numbers-full/main/nl-BE/numbers.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import currencies from 'cldr-numbers-full/main/nl-BE/currencies.json';
import caGregorian from 'cldr-dates-full/main/nl-BE/ca-gregorian.json';
import dateFields from 'cldr-dates-full/main/nl-BE/dateFields.json';
import timeZoneNames from 'cldr-dates-full/main/nl-BE/timeZoneNames.json';
import Config from '../../_helpers/config'
import {StockService} from '../../_services/stock.service'
import Button from '@material-ui/core/Button';
import {Grid, GridNoRecords} from "@progress/kendo-react-grid";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import BarcodeReader from 'react-barcode-reader'
const language = 'nl';

load(

    currencyData,
    numbers,
    currencies,
    caGregorian,
    dateFields,
    timeZoneNames
);
export function withState(WrappedGrid) {
    return class StatefullGrid extends React.Component {

        aggregates = [
            { field: this.props.group, aggregate: 'count' }
        ];
        
        state = this.createAppState({
            skip: 0,
            take: 100000,
            group: [
                { field: this.props.group }
            ]
        });

        constructor(props) {
            super(props);
            this.handleConfirmSetSent = this.handleConfirmSetSent.bind(this);
            this.handleConfirmCloseNo = this.handleConfirmCloseNo.bind(this);
            this.handleConfirmCloseYes = this.handleConfirmCloseYes.bind(this);
            this.handleClose= this.handleClose.bind(this);
            this.handleScan= this.handleScan.bind(this);
            this.handleError= this.handleError.bind(this);
        }

        render() {
            let gridType = this.props.gridType;
            return (
                <div>
                    {gridType == "tocheck" &&
                    <BarcodeReader
                        onError={this.handleError}
                        onScan={this.handleScan}
                    />}

                    {gridType == "tosend" &&
                    <Button variant="contained" color="primary" onClick={this.handleConfirmSetSent}>
                        Geselecteerde items vertrokken op rondrit
                    </Button>
                    }
                    <LocalizationProvider language="nl-BE">

                        <IntlProvider locale={'nl-BE'} >
                            <WrappedGrid
                                filterable={false}
                                sortable={false}
                                pageable={false}
                                groupable={false}
                                scrollable={'scrollable'}
                                {...this.props}
                                
                                style={{ height: "calc(100vh - 150px)" }}
                                total={this.state.total}
                                data={this.state.result}
                                {...this.state.dataState}
                                onSelectionChange={this.selectionChange}
                                onDataStateChange={this.dataStateChange}
                                onHeaderSelectionChange={this.headerSelectionChange}
                                onExpandChange={this.expandChange}
                                expandField="expandedRow"
                                selectedField="selected"
                                cellRender={this.cellRender}
                            > 
                            </WrappedGrid>
                        </IntlProvider>
                    </LocalizationProvider>
                    <Dialog
                        open={this.state.confirmOpen??false}
                        onClose={()=>{this.handleConfirmCloseNo()}}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{this.state.dialogTitle}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">

                                {this.state.dialogDescription}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={()=>{this.handleConfirmCloseNo()}} color="primary">
                                Nee
                            </Button>
                            <Button onClick={()=>{this.handleConfirmCloseYes()}} color="primary" autoFocus>
                                Ja
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Snackbar
                        open={this.state.open}
                        onClose={()=>{this.handleClose()}}
                        autoHideDuration={3000}
                    >
                        <Alert onClose={()=>{this.handleClose()}} severity={this.state.severity}>
                            {this.state.alertmessage}
                        </Alert>
                    </Snackbar>
                </div>
            );
        }
        componentDidMount()
        {
            this.fetchData(this.state.dataState);
            this.setState({confirmOpen:false, open:false});
        }
        createAppState(dataState) {
            const groups = dataState.group;
            if (groups) { groups.map(group => group.aggregates = this.aggregates); }
            return {

                dataState: dataState
            };
        }
        handleClose = (event, reason) => {
            this.setState({open:false});
        };
        handleConfirmSetSent()
        {
            let currentComponent = this;

            currentComponent.setState({dialogAction:'handleSetSent', dialogDescription:"Bent u zeker u deze artikelen wilt verzenden?", dialogTitle: "Artikelen verzenden",confirmOpen:true});
        }
        handleConfirmCloseYes = (event) => {
            console.log("yes");
            this.setState({confirmOpen:false});
            if(this.state.dialogAction == 'handleSetSent')
            {
                this.handleSetSent();
            }
        };

        handleConfirmCloseNo = (event) => {
            console.log("no");
            this.setState({confirmOpen:false});
        };

        handleScan(data){
            var items = [];
            this.state.result.forEach(dataItem => {
                items.push(dataItem.items.filter(function (item){
                    return item.barcode === data;
                }));
            });
            items = [].concat.apply([], items);
            this.setState({
                validBarcodeScanned: items.length > 0
            })
            if(!this.state.validBarcodeScanned)
            {
                this.setState({alertmessage:"Product met deze barcode werd niet gevonden in deze lijst",severity:"error", open:true});
            }
            else {
                //this.props.history.push(`/stock/transfers/${this.props.gridType}/detail/${items[0].id}`);
                this.props.itemScanned(items[0]);
            }

        }
        handleError(err){
            console.error(err)
        }
        handleSetSent = () =>
        {

            var items = [];
            this.state.result.forEach(dataItem => {
                items.push(dataItem.items.filter(function (item){
                    return item.selected;
                }));
            });

            StockService.setSent([].concat.apply([], items)).then(result => {
            // login successful if there's a user in the response
            if (result === 'success') {
                this.setState({alertmessage:"Artikel(s) werden verzonden",severity:"success", open:true});
                this.fetchData(this.state.dataState)
            }
            else {
                this.setState({alertmessage:"Er was een probleem. Gelieve opnieuw te proberen",severity:"error", open:true});
            }
            return result;
        });

        }

        handleDataStateChange = (changeEvent) => {
            this.setState(changeEvent.data);
            this.fetchData(changeEvent.data);
        }
        headerSelectionChange = (event) => {
            const checked = event.syntheticEvent.target.checked;
            const data = this.state.result.map(item=>{
                item.items.map(i=> {
                    i.selected = checked;
                    return i;
                });
                return item;
            });
             this.setState({ result:data });
        }

        fetchData(dataState) {
            const queryStr = `${toDataSourceRequestString(dataState)}`; // Serialize the state
            const hasGroups = dataState.group && dataState.group.length;



            const base_url = `${Config.ApiUrl}/stock/${this.props.gridType}`;
            const init = { method: 'GET', accept: 'application/json', headers: authHeader() };

            fetch(`${base_url}?${queryStr}`, init)
                .then(response => response.json())
                .then(({ data, total }) => {

                    data.forEach(function (dataItem) {
                        dataItem.items.map(i=> {
                            i.selected = false;
                            return i;
                        });
                        //dataItem.items.foreach(function (item) {item["selected"] = false});
                    });
                    if (total === 0) {
                        this.props.handlerNoRecords();
                    }
                    //data.forEach(dataItem =>console.log(dataItem));
                    var res = hasGroups ? translateDataSourceResultGroups(data) : data;
                    res.forEach(dataItem => dataItem.expandedRow = false);
                    this.setState({
                        result: res,
                        total: total,
                        dataState : dataState
                    });
                    this.grid = document.querySelector('.k-grid');
                });
          

        }
        selectionChange = (event) => {
            const data = this.state.result.map(item=>{
                item.items.map(i=> {
                    if (i.id === event.dataItem.id) {
                        i.selected = !event.dataItem.selected;
                    }
                    return i;
                });
                return item;
            });
            this.setState({ result:data });

        }
        dataStateChange = (event) => {
            this.setState(this.createAppState(event.data));
            
        }

        expandChange = (event) => {
            console.log(event.dataItem);
            event.dataItem[event.target.props.expandField] = event.value;
            console.log("expanding change");
            console.log(event.dataItem);
            this.setState({
                result: this.state.result,
                dataState: this.state.dataState
            });

            event.dataItem.expanded = !event.dataItem.expanded;
            this.forceUpdate();
        }

        cellRender = (td, props) => {

            if (props.rowType === 'groupFooter') {
                return(<td style={{display: 'none'}}/>);
            }

            if (td && td.props.children && props.rowType === "groupHeader") {
                let children = <span>
        {/*<span style={{ width: this.firstColumnWidth, float: "left" }}>{td.props.children.props.children}</span>*/}
                    <span className="customGroupHeader">
          <a href="#"
             tabIndex="-1"
             className={props.expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'}
             onClick={(e) => {
                 e.preventDefault();
                 if (props.onChange) {
                     props.onChange({
                         dataItem: props.dataItem,
                         syntheticEvent: e,
                         field: undefined,
                         value: !props.expanded
                     });
                 }
             }}></a>
                        {/*<FormControlLabel*/}
                        {/*control={*/}
                        {/*<Checkbox*/}
                        {/*icon={<CheckBoxOutlineBlankIcon fontSize="small" />}*/}
                        {/*checkedIcon={<CheckBoxIcon fontSize="small" />}*/}
                        {/*value="false" onChange={handleSend(props.dataItem.items)}*/}
                        {/*/>*/}
                        {/*}*/}
                        {/*label="Verzonden"*/}
                        {/*/>*/}

                        {props.dataItem.value} ({props.dataItem.items.length})
            </span>

      </span >
                return React.cloneElement(td, td.props, children);
            }
            return td
        }
    }
    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

}